import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";
import device from '../../assets/images/device.png';


class Priority extends Component {

    render() {
        return (
            <React.Fragment>
              <section className='priority'>
                  <Container>
                    <Row>
                      <Col md="5" sm="12">
                        <img src={device} alt="Priority Member" className="img-fluid device" />
                      </Col>
                      <Col md="7" sm="12">
                        <h1>Join Prioritas Member</h1>
                        <p>TaLorem ipsum dolor sit amet, consectetuer adipiscing elit,sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam</p>                      
                      </Col>
                    </Row>
                  </Container>
              </section>
            </React.Fragment>
        );
    }
}

export default Priority;